import React from "react";
import { Select, Spin, Icon } from "antd";
import { Constant } from "../../config/index";
import axios from "axios";

function debounce(func, delay = 500) {
  let timer;

  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

class UserSearchForm extends React.Component {
  state = {
    searchLoading: false,
    searchedList: [],
  };

  handleOnSearch = async (search) => {
    this.setState({
      searchLoading: true,
    });

    if (String(search).trim().length === 0) {
      this.setState({
        searchLoading: false,
      });
      return;
    }

    this.setState({
      searchedList: await this.getMemberList(search),
      searchLoading: false,
    });
  };

  getMemberList = async (search) => {
    let resp;
    const token = localStorage.getItem(Constant.SessionKey);
    const url = `${Constant.MEMBER_SEARCH}`;
    const opt = {
      headers: { Authorization: `Bearer ${token}` },
      method: "GET",
      params: {
        search: search,
      },
      url,
    };

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp.data);
      return [];
    }

    if (resp.data.error) {
      console.log(resp.data.error);
      return [];
    }

    return resp.data.data || [];
  };

  handleOnSelect = (val) => {
    const { valueCallback } = this.props;
    valueCallback(val);

    this.setState({
      value: val,
    });
  };

  render() {
    const { memberList, isModify, existList, value, disabled, style } =
      this.props;

    const renderList = () => {
      let targetList = [];
      if (this.state.searchedList.length > 0) {
        targetList = this.state.searchedList;
      } else {
        targetList = memberList || [];
      }
      let items = [];
      for (const element of targetList) {
        const isExist =
          existList &&
          existList.findIndex((x) => x.member_id === element.id) !== -1;

        if (isExist) {
          continue;
        }

        items.push(
          <Select.Option key={String(element.id) + "ID"} value={element.id}>
            {element.id} | {element.email}
          </Select.Option>
        );
      }

      return items;
    };

    return (
      <Select
        showSearch
        placeholder="Select Member"
        optionFilterProp="children"
        filterOption={(input, option) => {
          if (typeof option.props.children[2] === "undefined") return false;

          const val = (option.props.children[2] || "").toLowerCase();
          const ipt = (input || "").toLowerCase();

          return val.indexOf(ipt) >= 0;
        }}
        onSearch={debounce((search) => this.handleOnSearch(search), 500)}
        loading={this.state.searchLoading}
        notFoundContent={
          this.state.searchLoading ? (
            <div>
              <Spin size="small" /> Loading the sender list...
            </div>
          ) : (
            <div>
              <Icon type="question" /> Please input an email first.
            </div>
          )
        }
        onChange={(val) => this.handleOnSelect(val)}
        value={value === 0 ? null : value}
        disabled={isModify || disabled}
        allowClear
        style={style || {}}
      >
        {renderList()}
      </Select>
    );
  }
}

export default UserSearchForm;



// WEBPACK FOOTER //
// ./src/containers/User/user-search-form.js